import Icon from "./Icon.jsx";
import { truncate } from "../lib/format.js";

/**
 * Deliberately does NOT repeat the Decision card. That panel says what to do;
 * this one says what moved and what is owed.
 */
export default function Briefing({ signals, actions, learned }) {
  return (
    <div
      style={{
        width: 290,
        borderLeft: "1px solid var(--brd)",
        padding: "22px 18px",
        flexShrink: 0,
        overflow: "auto",
        background: "rgba(17,17,24,0.6)",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 18 }}>
        <div
          style={{
            width: 30,
            height: 30,
            borderRadius: 10,
            background: "var(--vg)",
            border: "1px solid rgba(245,197,24,0.1)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Icon name="bolt" size={15} color="var(--volt)" fill />
        </div>
        <div>
          <div style={{ fontFamily: "var(--d)", fontSize: 14, fontWeight: 700 }}>
            Fulminio Briefing
          </div>
          <div style={{ fontSize: 11, color: "var(--t3)" }}>Market intelligence</div>
        </div>
      </div>

      <Label color="var(--volt)">What changed today</Label>
      {signals.length > 0 ? (
        signals.slice(0, 5).map((s, i) => (
          <div key={i} style={{ display: "flex", gap: 9, marginBottom: 12, fontSize: 13 }}>
            <span
              style={{ color: "var(--t3)", flexShrink: 0, width: 24, fontSize: 11, paddingTop: 1 }}
            >
              {i + 1}h
            </span>
            <div style={{ minWidth: 0 }}>
              <div style={{ color: "var(--t1)", fontWeight: 500, marginBottom: 2 }}>
                {s.company}
              </div>
              <div style={{ color: "var(--t3)", fontSize: 12, lineHeight: 1.45 }}>
                {truncate(s.signal, 70)}
              </div>
            </div>
          </div>
        ))
      ) : (
        <div style={{ fontSize: 13, color: "var(--t3)", marginBottom: 16 }}>
          No new signals yet. Run the Radar to scan.
        </div>
      )}

      <Label color="var(--green)" top>
        Follow-ups due
      </Label>
      {actions.length > 0 ? (
        actions.slice(0, 4).map((a, i) => (
          <div
            key={i}
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: 9,
              padding: "9px 0",
              borderTop: i > 0 ? "1px solid var(--brd)" : "none",
              fontSize: 13,
            }}
          >
            <div
              style={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                background: "var(--green)",
                marginTop: 6,
                flexShrink: 0,
              }}
            />
            <div style={{ minWidth: 0 }}>
              <div style={{ color: "var(--t1)", fontWeight: 500 }}>{a.company}</div>
              <div style={{ color: "var(--t3)", fontSize: 12, lineHeight: 1.45, marginTop: 1 }}>
                {truncate(a.action, 65)}
              </div>
            </div>
          </div>
        ))
      ) : (
        <div style={{ fontSize: 13, color: "var(--t3)" }}>Nothing due right now.</div>
      )}

      {learned.length > 0 && (
        <>
          <Label color="var(--purple)" top>
            Fulminio learned
          </Label>
          {learned.map((l, i) => (
            <div
              key={i}
              style={{
                fontSize: 13,
                color: "var(--t2)",
                lineHeight: 1.55,
                padding: "9px 0",
                borderTop: i > 0 ? "1px solid var(--brd)" : "none",
              }}
            >
              {truncate(l.text, 100)}
            </div>
          ))}
        </>
      )}
    </div>
  );
}

function Label({ children, color, top }) {
  return (
    <div
      style={{
        fontSize: 11,
        fontWeight: 700,
        color,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        marginBottom: 10,
        marginTop: top ? 22 : 0,
      }}
    >
      {children}
    </div>
  );
}
